// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"592eb5e6","434":"fbfa62b0","455":"4afed04e","834":"5dfa2b85","977":"d480f6e2"}[chunkId] + ".chunk.js";
};